import React, { useState, useEffect, useCallback } from "react";

import Overlay from "./components/UI/Overlay";
import Identity from "./components/Identity";
import Scramble from "./components/Scramble";
import TimeList from "./components/TimeList";
import TimeCard from "./components/TimeCard";
import Stats from "./components/Stats";
import VizHistogram from "./components/VizHistogram";
import VizPlot from "./components/VizPlot";
import MobileFooter from "./components/MobileFooter";
import Summary from "./components/Summary";
import ColorBar from "./components/ColorBar";
//import DesktopInfo from "./components/DesktopInfo";

import "./App.css";

import { fQuantile, findSESOptimalAlpha, simpleExponentialSmoothing  } from "./components/StatFunctions";


const version = 2.0;

// This was implemented to overcome a non-recoverable issue
// that was based on the format of older data with this newer app.
// In the future, I could offer more refinement for example by
// warning the user that they are going to lose all their solves,
// and by checking for certain version numbers, rather than just
// checking to see if 'version' is in each time object.
const validateStorage = (objects)=> {
  const n = objects.length
  const versions = objects.map((x)=>x.version);
  const hasIdKey = objects.every(obj => obj.hasOwnProperty('version'));
  return hasIdKey;
}

console.log("test")

const App = (props) => {
  const [isActive, setIsActive] = useState(false);
  const [startTime, setStartTime] = useState();
  const [seconds, setSeconds] = useState(null);
  const [sessionTimes, setSessionTimes] = useState(null);
  const [thisScramble, setThisScramble] = useState();
  const [showTimer, setShowTimer] = useState(true);
  const [updateScramble,setUpdateScramble] = useState(false);
  const [puzzle, setPuzzle] = useState('3x3');
  const [progress, setProgress] = useState(100);
  const [progressTarget, setProgressTarget] = useState(900);

  // if (sessionTimes === null) {
  //   console.log("Getting local storage")
  //   const dsx = localStorage.getItem("data");
  //   console.log(dsx)
  //   if (dsx !== null) {
  //     let sx = JSON.parse(dsx);
  //     console.log(sx)
  //     if(validateStorage(sx)){
  //       setSessionTimes(sx);
  //     }else{
  //       localStorage.clear();  // see comments on ValidateStorage for explanation.
  //     }
  //   }
  //   const puzzleType = localStorage.getItem("puzzle");
  //   if(puzzleType && puzzleType !== null){
  //     setPuzzle(puzzleType)
  //   }
  // }

 
  useEffect(() => {
    if (sessionTimes === null) {
      const dsx = localStorage.getItem("data");
      if (dsx !== null) {
        let sx = JSON.parse(dsx);
        if(validateStorage(sx)){
          setSessionTimes(sx);
        }else{
          localStorage.clear();  // see comments on ValidateStorage for explanation.
        }
      }
      const puzzleType = localStorage.getItem("puzzle");
      if(puzzleType && puzzleType !== null){
        setPuzzle(puzzleType)
      }

    }
  
    return () => {}
  }, [])
  





  const fixLocalStorage = () => {
    let x = sessionTimes

    for(let i = 0; i < x.length; i++){
      x[i].id = x.length-i;
      x[i].key = x[i].id
    }
    localStorage.setItem("data", JSON.stringify(x));
  }

  const addTime = () => {

    let newId = 1
    if(sessionTimes){
      newId = sessionTimes[0].id + 1;
    }else{
      newId = 1
      setProgressTarget(seconds)
    }

    let newIdpx = 1
    let top5 = false
    let top10 = false
    let met_target=false
    let outlier = false
    let target = seconds
    let optAlpha = -1;
    if(sessionTimes){
      let sf = sessionTimes.filter((x)=>x.puzzle === puzzle)
      if(sf.length > 0){
        newIdpx = sf[0].idpx + 1;

        // Time vales
        const vx = sf.map((ele)=>{
          return ele.item;
        })
        vx.unshift(seconds); //inserts the value at first element in array

        // Sorted time values
        const vxs = [...vx].sort((a, b) => a - b);

        
        if(vxs.slice(0,5).includes(seconds)){
          top5 = true
        }
        if(vxs.slice(0,10).includes(seconds)){
          top10 = true
        }

        // console.log(progressTarget)
        if(seconds < sf[0].target){
          met_target = true
        }
        
        const q1 = fQuantile(vx, 0.25);
        const q3 = fQuantile(vx, 0.75);
        const iqr = (q3 - q1);
        const outlier_lower = q1 - 1.5 * iqr
        const outlier_upper = q1 + 1.5 * iqr
        if(seconds < outlier_lower){
          outlier = true
        }
        if(seconds > outlier_upper){
          outlier = true
        }
        // console.log(seconds + " vs outlierlims: " + outlier_lower + ", " + outlier_upper);

        let bestAlpha = findSESOptimalAlpha(vx.toReversed());
        let ses = simpleExponentialSmoothing(vx.toReversed(), bestAlpha)
        let forecast = ses[ses.length-1];

        // console.log(ses.length + " " + bestAlpha + " " + forecast)
        target = forecast
        optAlpha = bestAlpha
        setProgressTarget(target)

        

      }else{
        top5 = true;
        top10 = true;
        target = seconds
        met_target = true;
        optAlpha = -1;
        setProgressTarget(target)
      }
    }

    const newTime = {
      id: newId,
      key: newId,
      idpx: newIdpx, // puzzle-specific id
      puzzle: puzzle,  //'3x3', '2x2', etc.
      item: seconds,
      scramble:thisScramble[0],
      top5: top5,
      top10: top10,
      target: target,
      met_target: met_target,
      outlier: outlier,
      optalpha: optAlpha,
      version: version,
    };    

    console.log(newTime)


    if (!sessionTimes) {
      setSessionTimes([newTime]);
      localStorage.setItem("data", JSON.stringify([newTime]));
    } else {
        setSessionTimes((prevTimes) => {
          localStorage.setItem("data", JSON.stringify([newTime, ...prevTimes]));  //updates local storage
          const rx = [newTime, ...prevTimes];                                     // new state
          return rx;                                                              // updated

        });
        
    }
  };



  // Removes the most recently added element
  const removeTime = () => {
    if (sessionTimes === null) {
      return;
    }else{
      if (sessionTimes.length === 1) {
        localStorage.removeItem("data");
        setSeconds(null);
        setSessionTimes(null);
      }else{
        let sfx = sessionTimes.filter((x)=>x.puzzle === puzzle)
        let n = sfx.length;
        if(n > 0){
          let idToRemove = sfx[0].id
          // console.log(idToRemove)
          let newdata = sessionTimes.filter(e=>e.id !== idToRemove)
          setSeconds(null);
          setSessionTimes(newdata);
          localStorage.setItem("data", JSON.stringify(newdata));                 
        }
      }

    }
    

  };

  const resetSession = () => {

    if(window.confirm("Reset session? This will delete all times.")){
      console.log("reset")
      localStorage.removeItem("data");
      setSeconds(null);
      setSessionTimes(null);      
      savePuzzle('3x3')
    }    

  };

  // const markDNF = () => {

  //   // let savedTime = sessionTimes[0];
  //   // savedTime.dnf = true;
  //   // let x = sessionTimes.slice(1);
  //   // x = [savedTime, ...x]
  //   // setSessionTimes(x)
  //   console.log("App.js: markDNF() - disabled")

  // }

  // const markPenalty = () => {
  //   // let savedTime = sessionTimes[0];
  //   // savedTime.penalty = true;
  //   // let x = sessionTimes.slice(1);
  //   // x = [savedTime, ...x]
  //   // setSessionTimes(x)    
  //   console.log("App.js: markPenalty() - disabled")

  // }

  const toggleTimer = () => {
    setShowTimer(!showTimer);
  }

  const savePuzzle = (puzzleType) => {
    setPuzzle(puzzleType)
    localStorage.setItem("puzzle", puzzleType)
    setSeconds(null)  // this causes 'geTimer' to be displayed, replacing any previous time
    setUpdateScramble(true);
  }

  // This is called from MobileFooter via props
  function puz2(){
    savePuzzle('2x2')
    
  }
  // This is called from MobileFooter via props
  function puz3(){
    savePuzzle('3x3')

  }  



  const keyPressHandler = (e) => {
    e.preventDefault();
    console.log(e.code);

    if (e.code !== "Space") {

      if (e.code === "Delete" && !isActive) {
        removeTime();
        return;
      }
      if (e.code === "KeyR" && !isActive) {
        resetSession();
        return;
      }
      // if (e.code === "KeyD" && !isActive) {
      //   markDNF();
      //   return;
      // }    
      // if (e.code === "KeyP" && !isActive) {
      //   markPenalty();
      //   return;
      // }      
      if (e.code === "KeyH") {
        toggleTimer();
        return;
      }      

      if (e.code === "KeyQ" && !isActive) {
        fixLocalStorage();
        return;
      }      
      if (e.code === "KeyS" && !isActive) {
        setUpdateScramble(true);
        return;
      }
      if ( !isActive && (e.code === "Digit2" || e.code === "Numpad2")) {

        savePuzzle('2x2')

        //console.log('2x2 puzzle')
        return;
      }      
      if ( !isActive && (e.code === "Digit3" || e.code === "Numpad3") ) {
        savePuzzle('3x3')
        //console.log('3x3 puzzle')
        return;
      }      
      return;
    }else{
      if (!isActive) {
        setIsActive(true);
        setStartTime(Date.now());
      } else {
        setIsActive(false);
        addTime();
      }
    }




  };

  //let showSeconds = "Solve";
  let showSeconds = seconds

  if (!isActive) {
    if (seconds === null) {
      showSeconds = null;
    } else {
      showSeconds = sessionTimes[0].item;
    }
  }

  const progressValue = (tgtmax) => {
    let y = tgtmax-seconds
    let z = y * 100 / tgtmax
    if(z < 0){
      z = 0
    }
    setProgress(z)
    //console.log(z)    
  }
  //console.log(showSeconds)

  const insertScramble = useCallback((newScram) => {
    setThisScramble(newScram);
    setUpdateScramble(false)
    // console.log("App.js 73 [new]:  " + newScram);
  }, []);

  
  // Set the target time to solve
  // useEffect(() => {
  //   if ( !isActive && sessionTimes) {
  //       let x = sessionTimes.filter( (x)=>x.puzzle === puzzle )
  //       if(x.length >= 1){
  //         setTarget(x[0].target)
  //         console.log("Target changed from " + target.toFixed(3) + " to " + x[0].target.toFixed(3))
  //       }else{
  //         setTarget(900)
  //       }
  //   }
  //   return () => {}
  // }, [isActive, puzzle, sessionTimes])
  
  


  // This is the timer!
  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds((seconds) => (Date.now() - startTime) / 1000);
        progressValue(progressTarget)
      }, 5);
    } else if (isActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [isActive, startTime, seconds]);

  const pointerHandler = (e) => {
    // console.log(e);
    if (!isActive) {
      setIsActive(true);
      setStartTime(Date.now());
    } else {
      setIsActive(false);
      // console.log(seconds);
      addTime();
    }
  };

  let timerClassName = "timer";
  if(!showTimer){
    timerClassName = "timer hide"
  }

   
  return (
    <Overlay>
      {/* <main id='main' tabIndex='0' onKeyDown={keyPressHandler} className="main"> */}
      <main
        id="main"
        tabIndex="0"
        onKeyUp={keyPressHandler}
        ref={(vv) => vv && vv.focus()}
      >
        <div className="container-left">
          <div className="identity">
            {/* <Identity rmTime={removeTime} rmAll={resetSession} dnf={markDNF} penalty={markPenalty}/> */}
            <Identity rmTime={removeTime} rmAll={resetSession}  puznow={puzzle} puz2={puz2} puz3={puz3}/>
          </div>

          <div className="list">
              <TimeList data={sessionTimes && sessionTimes.filter((x)=>x.puzzle === puzzle)} del={removeTime} />
          </div>


          <div className="stats">
            <Stats data={sessionTimes && sessionTimes.filter((x)=>x.puzzle === puzzle)} isSolving={isActive}></Stats>
          </div>

        </div>

        <div className="container-right">
          <div className="container-right-flex">
            {/* <div className="scramble"   onPointerUp={pointerHandler}> */}
            <div className={puzzle==='3x3' ? 'scramble3x3': 'scramble2x2'}   onPointerUp={pointerHandler}>
              <Scramble cts={isActive} update={updateScramble} sendToApp={insertScramble} puzzle={puzzle}/>
              
            </div>

            <div className={timerClassName} onPointerUp={pointerHandler}>
              <TimeCard tmSeconds={showSeconds} />
            </div>

            {/* <div>{progressTarget}</div> */}
            {/* <div>{thisScramble}</div> */}

            <ColorBar data={sessionTimes && sessionTimes.filter((x)=>x.puzzle === puzzle)} />

            <div className="progressbar-container">
              <div className="progressbar-ruler"></div>
              <div className="progressbar" style={{ width: `${progress}%` }}>&nbsp;</div>
            </div>

            <div className="summary" onPointerUp={pointerHandler}>
                <Summary data={sessionTimes && sessionTimes.filter((x)=>x.puzzle === puzzle)} solving={isActive} puzzle={puzzle}></Summary>
            </div>

            <div className="charts">
              <div className="plot">
                {/* <BoxPlot data={sessionTimes}></BoxPlot> */}
                {/* <PlotLine appData={sessionTimes}></PlotLine> */}
                {sessionTimes && <VizPlot data={sessionTimes && sessionTimes.filter((x)=>x.puzzle === puzzle)}></VizPlot> }
                
              </div>
              <div className="gram">
                {/* <Histogram data={sessionTimes}></Histogram> */}
                <VizHistogram data={sessionTimes && sessionTimes.filter((x)=>x.puzzle === puzzle)}></VizHistogram>
              </div>
            </div>

            {/* The footer is only visible on mobile */}
            <MobileFooter data={sessionTimes && sessionTimes.filter((x)=>x.puzzle === puzzle)} delete={removeTime} puznow={puzzle} puz2={puz2} puz3={puz3}></MobileFooter>
          </div>
        </div>
      </main>
    </Overlay>
  );
};

export default App;
